<template>
  <div style="min-height: 92vh">
    <ModuleHeader>Usuarios Administrativos</ModuleHeader>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <uv-data-table :config="config" :data="data_usuarios" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    <modal v-model="showModal" :showFooter="false" :title="titleForm" :key="modalKey">
      <UsuarioAdminForm :edit="editMode" :key="formIndex" @toggle="toggleModal" @sendData="sendData"
        :enablePassword="enablePassword" :usuarios="allUsernames" :dataEdit="editData"></UsuarioAdminForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import UsuarioAdminForm from "./UsuariosAdminForm.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "UsuariosAdminCRUD",
  components: {
    modal,
    UsuarioAdminForm,
    uvDataTable,
  },
  props: [],
  data() {
    return {
      overlay: false,
      editMode: false,
      editData: null,
      enablePassword: false,
      formIndex: 0,
      modalKey: 0,
      usuarios: [],
      allUsernames: [],
      showModal: false,
      titleForm: "",
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Usuarios",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addUser",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editUser",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteUser",
            require: true,
          },
        ],
        fields: [
          {
            text: "Usuario",
            value: "usuario",
          },
          {
            text: "Nombre",
            value: "displayName",
          },
          {
            text: "Tipo",
            value: "type",
          },
          {
            text: "Estatus",
            value: "enable",
            format: (row) => {
              const text = row.enable ? "Activo" : "Inactivo";
              const color = row.enable ? "green" : "red";
              return `<a class=' ${color}' style='display: inline-block; padding: 1px 10px;font-size: 14px;font-weight: bold;color: white;border-radius: 16px;text-align: center;text-decoration: none;min-width: 80px;'>${text}</a>`;
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Cambiar contraseña",
                buttonId: "changePassword",
                value: "id",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addUser") {
        this.formIndex++;
        this.modalKey++;
        this.titleForm = "Agregar Usuario";
        this.enablePassword = true;
        this.editMode = false;
        this.editData = {};
        this.allUsernames = this.data_usuarios.map((user) => {
          return user.usuario;
        });
        this.toggleModal(true);
      }
      if (buttonId == "editUser") {
        if (this.$store.getters.getFirebaseApp.tenant == "PCUN") {
          let claims = this.$route.params.user.tokenResult.claims;
          if (claims.Type != "SuperAdmin") {
            this.$swal("Error", "No tienes permiso para editar usuarios", "error");
            return;
          }
        }
        this.formIndex++;
        this.modalKey++;
        this.titleForm = "Editar Usuario";
        const user = this.$pgsHelper.getById(
          this.data_usuarios,
          "id",
          idSelected[0]
        );
        this.allUsernames = this.data_usuarios.map((user) => {
          return user.usuario;
        });
        this.editMode = true;
        this.editData = user;
        this.enablePassword = false;
        this.toggleModal(true);
      }
      if (buttonId == "deleteUser") {
        if (this.$store.getters.getFirebaseApp.tenant == "PCUN") {
          let claims = this.$route.params.user.tokenResult.claims;
          if (claims.Type != "SuperAdmin") {
            this.$swal("Error", "No tienes permiso para eliminar usuarios", "error");
            return;
          }
        }
        this.deleteUser(idSelected[0]);
      }
      if (buttonId == "changePassword") {
        this.formIndex++;
        this.modalKey++;
        this.titleForm = "Modificar Contraseña";
        const user = this.$pgsHelper.getById(
          this.data_usuarios,
          "id",
          idSelected
        );
        this.editData = user;
        this.editMode = true;
        this.enablePassword = true;
        this.toggleModal(true);
      }
    },
    async deleteUser(id) {
      const deletedObject = this.$pgsHelper.getById(this.data_usuarios, "id", id) || { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este usuario?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("GBL-Usuarios-deleteUsuario", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "USER_DELETE",
              Mensaje: `Usuario eliminado`,
              reference: { id: id, tp: "USUARIO", al: deletedObject.usuario || "" },
              data: deletedObject
            });
            this.$swal(
              "Usuario elimando",
              "El usuario se elimino correctamente",
              "success"
            );
            this.getUsers();
            this.$emit("changeIndex");
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    sendData(data, edit, changePassword) {
      let dataToSend = {
        un: data.usuario,
        tp: data.type,
        dn: data.displayName,
        en: data.enable,
      };

      if (edit) {
        dataToSend.Id = data.id;
        if (changePassword) {
          dataToSend.ps = data.password;
        }
      } else {
        dataToSend.ps = data.password;
        dataToSend.ex = {};
      }

      // console.log("dataToSend", dataToSend);

      const func = edit
        ? "GBL-Usuarios-updateUsuario"
        : "GBL-Usuarios-createUsuario";
      const swalName = edit ? "editar" : "crear";
      const swalAction = edit ? "editado" : "creado";

      this.$swal({
        title: `Desea ${swalName} este usuario`,
        text: `El usuario será ${swalAction} con los datos especificados`,
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call(func, dataToSend)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "USER_" + (edit ? "EDIT" : "CREATE"),
              Mensaje: `Usuario ${swalAction} : ${dataToSend.dn}`,
              reference: { id: (edit ? data.id : result.value.data.data.id), tp: "USUARIO", al: dataToSend.dn },
              data: dataToSend
            });
            this.$swal(
              `Usuario ${swalAction}`,
              `El usuario fue ${swalAction}`,
              "success"
            );

            this.showModal = false;
            this.formKey++;
            this.getUsers();
          } else {
            this.$swal(
              "Error guardando datos",
              "Hubo un error al guardar los datos, intenta más tarde",
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },
    async getUsers() {
      this.overlay = true
      let new_users = [];
      await this.$store.getters.getFirebaseApp.fba
        .call("GBL-Usuarios-getUsuarios", {
          tenant: this.$store.getters.getFirebaseApp.tenant,
        })
        .then((result) => {
          if (result.data.ok) {
            new_users = result.data.data;
          }
          this.overlay = false
        });

      /* const database = this.$store.getters.getFirebaseApp.database;
        let user = await this.$store.getters.getFirebaseApp.database
          .queryBuilder("RVA/Mayoristas/Usuarios",
            [
              database.orderByChild("EsAdmin"),
              database.equalTo(true)
            ]
          )
  
        if (user.exists()) {
          let us = {};
          let result = Object.entries(user.val());
          result.forEach((usu) => {
            let userData = { id: usu[0], ...usu[1] };
            this.$pgsHelper.log(userData);
            new_users.push(userData);
          });
  
        } else {
          console.log("No existen usuarios");
         } */

      this.usuarios = new_users;
      this.overlay = false
    },
    getUserName(fullUser) {
      this.$pgsHelper.log(fullUser);
      let dash = fullUser.split("_");
      let at = dash[1].split("@");
      return at[0];
    },
  },
  computed: {
    tipoUsuario() {
      return this.$route.params.user.tokenResult.claims.Type;
    },
    data_usuarios() {
      let data = [];
      // console.log(this.usuarios);
      this.usuarios.forEach((element) => {
        const dataElement = element.data;
        let user = {
          // codigoHotel: element.MCode,
          usuario: dataElement.un,
          id: element.id,
          enable: dataElement.en,
          type: dataElement.tp,
          displayName: dataElement.dn,
          // login: this.getUserName(element.Correo.toString()),
        };
        data.push(user);
      });

      return data;
    },
  },
  watch: {},
  mounted() { },
  created() {

    this.getUsers();
  },
};
</script>
